<template>
    <div id="app">
        <router-view />
        <notifications
            group="userActivity"
            :duration="3000"
            :width="width"
            classes="vue-notification"
            position="center top"
            animation-type="velocity"
            :animation="animation"
        >
            <template #body="props">
                <v-card :class="$vuetify.theme.dark ? 'notification-card-dark-' + props.item.type : 'notification-card-light-' + props.item.type">
                    <v-card-text :style="$vuetify.theme.dark ? 'color: #fff' : 'color: #000'">
                        <v-row align="center" justify="start">
                            <v-col cols="10" class="pa-0">
                                <div class="card-title-text font-weight-thin">{{ props.item.title }}</div>
                                <div class="card-title-subtext font-weight-thin text-truncate">{{ props.item.text }}</div>
                            </v-col>
                            <v-col cols="2" class="pa-0">
                                <v-btn text icon @click="props.close">
                                    <v-icon :style="$vuetify.theme.dark ? 'color: #fff' : 'color: #000'">mdi-close</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </template>
        </notifications>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'App',
    data: () => ({
        width: 500,
        animation: {
            enter(element) {
                let height = element.clientHeight;

                return {
                    height: [height, 0],
                };
            },
            leave: {
                height: 0,
                opacity: 0,
            },
        },
    }),
    computed: {
        ...mapState({
            toNotify: (state) => state.notification.toNotify,
        }),
    },
    watch: {
        toNotify() {
            let type;
            if (this.toNotify.type === 'warning') {
                type = 'warn';
            } else if (this.toNotify.type === 'info') {
                type = 'info';
            } else if (this.toNotify.type === 'error') {
                type = 'error';
            } else if (this.toNotify.type === 'success') {
                type = 'success';
            }
            this.$notify({
                group: 'userActivity',
                title: this.toNotify.message,
                text: this.toNotify.description,
                type: type,
            });
        },
    },
};
</script>

<style lang="scss">
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    //text-align: center;
    font-size: 15px;
    //padding: 5px 2px 25px 2px;
    //background-color: #f5f5f5;
}

.primary-color {
    color: #0a0f5c !important;
}

@media (max-width: 1440px) {
    #app {
        font-size: 14px !important;
    }
}
</style>
